/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Assistant/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFormat from 'Data/format.js'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'



/** @type {import('Simple/types.js').View} */
export default function Assistant({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Profile/Content/SchedulingPreferences/Content/Assistants/Set/Assistant"
  
}) {
let schedulingPreferencesAssistantEmployeeEmploymentContractPersonValueData = fromData.useDataFormat({ viewPath,
context: 'scheduling_preferences_assistant',
path: 'employee.employment_contract.person',
format: fromFormat.personName,
})
let dtColorsNeutral800 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.800'
        })
  return (<React.Fragment
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 color={dtColorsNeutral800}
 data="scheduling_preferences_assistant.employee.employment_contract.person"
 format="/Data/format.js personName"
 text={schedulingPreferencesAssistantEmployeeEmploymentContractPersonValueData}
/>
{children}
</React.Fragment>)
}